module.exports = __webpack_public_path__ + "img/joinus-4.735d34ab.png";